<script setup lang="ts">
import { useHeaderProps, usePageBodyStyle } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';
import {
  useConversationsHeaderCustomisation,
  useConversationsHeaderTitleCustomisation,
  useConversationsNavIcon1Customisation,
  useConversationsNavIcon2Customisation,
} from './composables/useConversationsHeaderCustomisation';
import GenericHeader from '@/components/GenericHeader.vue';
import OpenConversations from './OpenConversations.vue';
import ClosedOrResolvedConversations from './ClosedOrResolvedConversations.vue';

const { contentStyle } = usePageBodyStyle({
  registryId: PUI.REGISTRY_IDS.CONVERSATIONS_PAGE,
  sectionKey: PUI.CONVERSATIONS_SECTION_KEYS.BODY_BACKGROUND,
  blockKey: PUI.CONVERSATIONS_BLOCK_KEYS.BODY_SECTION,
});

const headerCustomisation = useConversationsHeaderCustomisation();
const titleCustomisation = useConversationsHeaderTitleCustomisation();
const navIcon1Customisation = useConversationsNavIcon1Customisation();
const navIcon2Customisation = useConversationsNavIcon2Customisation();

const { headerProps } = useHeaderProps({
  header: headerCustomisation,
  title: titleCustomisation,
  navIcon1: navIcon1Customisation,
  navIcon2: navIcon2Customisation,
});

const search = {
  isVisible: false,
};
</script>

<template>
  <div class="page-container">
    <GenericHeader
      :header="headerProps.header"
      :title="headerProps.title"
      :nav-icon1="headerProps.navIcon1"
      :nav-icon2="headerProps.navIcon2"
      :search="search"
    />

    <!-- Content Container - Scrollable -->
    <div class="content-container page-content" :style="contentStyle">
      <!-- Open Conversations Section -->
      <OpenConversations />

      <!-- Closed or Resolved Conversations Section -->
      <ClosedOrResolvedConversations />
    </div>
  </div>
</template>

<style scoped lang="scss">
.content-container {
  padding-bottom: 100px;
}
</style>
